import React from 'react';
import styles from './ActionTable.module.css';
import { EditOutlined, DeleteOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { Popconfirm } from 'antd';
import { useHistory } from 'react-router-dom';

const ActionTable = ({ record, link, noEdit, noDelete, deleteAction }) => {
  const history = useHistory();

  return (
    <div className={styles.action__container}>
      {!noEdit && (
        <Link to={`${link}edit/${record.id}`}>
          <EditOutlined className={`${styles.icon} ${styles.edit}`} />
        </Link>
      )}
      {noDelete || noEdit ? <span></span> : <span className={styles.divider} />}
      {!noDelete && (
        <Popconfirm
          title='Êtes-vous sûr ?'
          okText='Supprimer'
          cancelText='Annuler'
          placement='topRight'
          onConfirm={() => {
            if (deleteAction) {
              deleteAction(record.id);
              return;
            }
            history.push(`${link}delete/${record.id}`);
          }}
        >
          <DeleteOutlined className={`${styles.icon} ${styles.delete}`} />
        </Popconfirm>
      )}
    </div>
  );
};

export default ActionTable;
